import React from "react";
import { connect } from "react-redux";
import commonActions from "core/state/redux/data/common/actions";
import customerActions from "app/state/redux/data/customer/actions";
import WishlistDataContainer from "./wishlist-data-container";

const WishlistReduxContainer = (props) => {
  return <WishlistDataContainer {...props} />;
};

const mapStateToProps = (state) => ({
  customer: state.customer.data,
});

const mapDispatchToProps = (dispatch) => {
  return {
    lock: (callbackFunction) => {
      dispatch(commonActions.lock(callbackFunction));
    },
    login: (username, password, cartToken, callbackFunction) => {
      dispatch(customerActions.loginCustomer(username, password, cartToken));
    },
    continueButton: (username, password) => {
      dispatch(customerActions.loginCustomer(username, password));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WishlistReduxContainer);
